export default [
  {
    path: '/tamanho/',
    name: 'tamanho',
    component: () => import('../views/TamanhoView.vue'),
    redirect: { name: 'tamanho-listar' },
    children: [
      {
        path: 'welcome',
        name: 'tamanho-listar',
        meta: {
          title: 'Tamanho',
        },
        component: () => import('../views/TamanhoWelcomeView.vue'),
      },
      {
        path: 'add',
        name: 'tamanho-cadastrar',
        meta: {
          title: 'Tamanho cadastrar',
        },
        component: () => import('../views/TamanhoFormView.vue'),
      },
      {
        path: ':id',
        name: 'tamanho-editar',
        meta: {
          title: 'Tamanho editar',
        },
        component: () => import('../views/TamanhoFormView.vue'),
      },
    ],
  },
];
